'use client';

type PaginationProps = {
  page: number; // Zero-based, matching API page indexes.
  totalPages?: number;
  hasNext: boolean;
  loading?: boolean;
  onPageChange: (page: number) => void;
  label?: string;
  className?: string;
};

/** Shared lightweight controls. Do not invent a total for sentinel-based APIs. */
export default function Pagination({ page, totalPages, hasNext, loading = false, onPageChange, label = 'Pagination', className = '' }: PaginationProps) {
  if (page === 0 && (!hasNext || (totalPages !== undefined && totalPages <= 1))) return null;
  const previousDisabled = loading || page <= 0;
  const nextDisabled = loading || !hasNext || (totalPages !== undefined && page + 1 >= totalPages);
  const button = 'ui-button ui-button--ghost ui-button--icon shrink-0 disabled:text-muted disabled:hover:bg-transparent';
  return <nav aria-label={label} aria-busy={loading} className={`flex items-center ${className}`}>
    <button type="button" className={button} disabled={previousDisabled} aria-label="Previous page" title="Previous page" onClick={() => { if (!previousDisabled) onPageChange(page - 1); }}>
      <svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"><path d="m14 6-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" /></svg>
    </button>
    <span aria-current="page" aria-label={totalPages === undefined ? `Page ${page + 1}` : `Page ${page + 1} of ${totalPages}`} className="min-w-6 text-center text-xs font-medium tabular-nums text-muted">{page + 1}{totalPages !== undefined && <span> / {totalPages}</span>}</span>
    <button type="button" className={button} disabled={nextDisabled} aria-label="Next page" title="Next page" onClick={() => { if (!nextDisabled) onPageChange(page + 1); }}>
      <svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"><path d="m10 6 6 6-6 6" strokeLinecap="round" strokeLinejoin="round" /></svg>
    </button>
  </nav>;
}
